export default __webpack_public_path__ + "static/media/arrow-icon.7c1c99d1.svg";